export default "__VITE_ASSET__372cb879__"